import { LoadingButton } from '@mui/lab';
import {
    Box,
    Button,
    Grid,
    Dialog,
    IconButton,
    Stack,
    Typography,
    Divider
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Formik } from 'formik';

import get from "lodash/get";
import { useParams } from 'react-router-dom';
import map from "lodash/map";
import SaveIcon from '@mui/icons-material/Save';

import CloseIcon from '@mui/icons-material/Close';
import { useDispatch, useSelector } from "react-redux";
import validator from "./validatorPermise";

import InputCheckbox from "../../../components/form/InputCheck";
import AutoComplete from "../../../components/form/AutoComplete";

const Permises = ({
    __,
    open,
    close,
    __o,
    permise
}) => {
    const { id } = useParams();

    const [selected, setSelected] = useState([]);

    const current = useSelector(state => state.config.profile.permises);
    const permisesOptions = map(current?.data, ({ screen }) => ({ value: screen, label: screen }));

    const onSubmit = (values) => {
        permise(values);
    }

    const HandleCancelSelected = () => {
        setSelected([]);
        close();  
     }

     const initialValues = {
            screen: "",
            idProfile: Number(id),
            watch: false,
            add: false,
            update: false,
            delete: false
        }

    return (
        <div>
            <Dialog onClose={close} open={open} maxWidth="lg" fullWidth>
                <Box>
                    <Typography variant="h6" sx={{ mt: 2, mb: 1, ml: 3 }}>
                        {__("labels.3")}
                    </Typography>
                    <IconButton
                        aria-label="close"
                        onClick={HandleCancelSelected}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </Box>
                <Divider />
                <Formik initialValues={initialValues} validationSchema={validator(__)} onSubmit={onSubmit}>
                    {formik => (
                        <form onSubmit={get(formik, "handleSubmit")}>
                            <Box className='p-4' >
                                <Grid container spacing={{ xs: 2, md: 3 }} alignItems="center">
                                    <Grid item xs={12} sm={6}>
                                        <AutoComplete
                                            name={"screen"}
                                            formik={formik}
                                            label={__(`form.screen.label`)}
                                            placeholder={__(`form.screen.placeholder`)}
                                            options={permisesOptions}
                                            loading={get(current, "isLoading")}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={1.5}>
                                        <InputCheckbox
                                            formik={formik}
                                            name="watch"
                                            label={__(`form.watch.label`)}
                                            placeholder={__(`form.watch.placeholder`)}
                                            // disabled={!!id || get(current, "isLoading", false) || get(post, "isLoading", false) || get(put, "isLoading", false)}
                                            />
                                    </Grid>
                                    <Grid item xs={12} sm={1.5}>
                                        <InputCheckbox
                                            formik={formik}
                                            name="add"
                                            label={__(`form.add.label`)}
                                            placeholder={__(`form.add.placeholder`)}
                                            // disabled={!!id || get(current, "isLoading", false) || get(post, "isLoading", false) || get(put, "isLoading", false)}
                                            />
                                    </Grid>
                                    <Grid item xs={12} sm={1.5}>
                                        <InputCheckbox
                                            formik={formik}
                                            name="update"
                                            label={__(`form.update.label`)}
                                            placeholder={__(`form.update.placeholder`)}
                                            // disabled={!!id || get(current, "isLoading", false) || get(post, "isLoading", false) || get(put, "isLoading", false)}
                                            />
                                    </Grid>
                                    <Grid item xs={12} sm={1.5}>
                                        <InputCheckbox
                                            formik={formik}
                                            name="delete"
                                            label={__(`form.delete.label`)}
                                            placeholder={__(`form.delete.placeholder`)}
                                            // disabled={!!id || get(current, "isLoading", false) || get(post, "isLoading", false) || get(put, "isLoading", false)}
                                            />
                                    </Grid>
                                </Grid>
                            </Box>
                            <Stack className='p-4' direction="row" spacing={2} justifyContent="flex-end">
                                <LoadingButton className='w-[100px] min-w-[100px]' variant="contained"  startIcon={<SaveIcon />} color="secondary" type='submit' loading={get(current, "isLoading")}>{__("action.save")}</LoadingButton>
                                <Button className='w-[100px] min-w-[100px]' variant='outlined' color="secondary" onClick={HandleCancelSelected} >{__(`action.cancel`)}</Button>
                            </Stack>
                        </form>
                        )}
                </Formik>
            </Dialog>
        </div >
    );
}

export default Permises